import React from "react";

interface FilterBoxHeaderProps {
  title: string;
  subTitle?: string;
  isActive: boolean;
  onClick: () => void;
  numAvailableSeats: number;
  track?: string;
}

// const subtext = (text: string | undefined) => {
//   if (!text) return null;
// 
//   return <div className="tw-text-[10px] md:tw-text-[14px] tw-font-[500]">{text}</div>;
// };

export const FilterBoxHeader: React.FC<FilterBoxHeaderProps> = ({ title, subTitle, isActive, onClick, numAvailableSeats, track }) => {
  const isBattleKart = track === "BATTLE_KART_TRACK";

  return (
    <div
      className={`tw-flex-1 ${numAvailableSeats > 0 || isActive ? "tw-cursor-pointer tw-text-white" : "tw-text-[#808080]"} tw-font-bold tw-py-[5px] tw-rounded-[10px] ${
        isActive ? (isBattleKart ? "tw-bg-[#EA581A]" : "bg-gradient-3") : "tw-bg-transparent"
      }`}
      onClick={() => {
        if (numAvailableSeats > 0) {
          onClick();
        }
      }}
    >
      <div className={`tw-text-[12px] md:tw-text-[18px] tw-font-[700] ${isBattleKart ? "add-grobold-font" : ""}`}>{title}</div>
      {/* {subtext(subTitle)} */}
      {/* {subtext(numAvailableSeats === 0 ? "Sold Out" : `${numAvailableSeats} available`)} */}
    </div>
  );
};
